export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    /* -------------------
    variation accordion
    ---------------------*/


    $('table.variations td.label').click(function (e) {
      e.stopPropagation();
      $(this).parent().find('td.value').slideToggle('medium');
      $(this).find('label').toggleClass('toggleLabelIcon');
      $(this).parent().siblings().find('td.value').slideUp();
      $(this).parent().siblings().find('label.toggleLabelIcon').removeClass('toggleLabelIcon');

    });
    //outside click
    $(document).bind('click', function (e) {
      e.stopPropagation();
      var trigger = $('table.variations tr');
      if (!trigger.is(e.target) && trigger.has(e.target).length === 0) {
        //$('table.variations td.value').slideUp();
      }

    });



    //select active
    var obj = $('.variations_form input[type="radio"]').filter(':checked');
    $.each(obj, function () {
      $(this).parent().parent().parent().addClass('active-attribute');
    });


    //add after
    var tr = $('table.variations tr:nth-child(2)');
    var trAccordion = $('<tr class="attribute-pa_customize"><td class="label"><label for="pa_lie">Customize Putt</label></td></tr>')
    $(trAccordion).insertAfter(tr);
    $(trAccordion).nextAll().hide();
    $(trAccordion).on('click', function () {
      $(this).nextAll().slideToggle();
      $(this).find('label').toggleClass('toggleAccordionIcon');
    });

    $('.variations_form input[type="radio"]').change(function () {
      if ($(this).is(':checked')) {
        //alert('check');
        $(this).parent().parent().parent().addClass('active-attribute');
      } else {
        $(this).parent().parent().parent().removeClass('active-attribute');
      }
      /*$('#list-var').html('');
      $('.variations_form input[type="radio"]').each(function() {
        if ($(this).is(':checked')) {
        var item = $(this).val();
        var li = '<li>'+item+'</li>';
        console.log(li);
        $(li).appendTo('#list-var');
        }
      });*/
    });

    // Empty cart button
    $('table.variations td.value a.reset_variations').remove()
    //$('.single_variation_wrap').prepend('<p><a class="reset_variations" href="">Rimuovi elementi selezionati</a></p>')

    //scroll  
    var banner = $('.banner .top-menu-container').outerHeight();
    var sidebar = $('#sidebar-summary');
    $(window).scroll(function () {
      var distance = $(window).scrollTop();
      console.log(distance);
      if (distance > banner) {
        $(sidebar).addClass('sidebar-fixed');
      } else {
        $(sidebar).removeClass('sidebar-fixed');
      }
    });

    // Move tabs over video
    $('.woocommerce-tabs').appendTo('.woocommerce-product-gallery')

    // Hide 'x' icon for 'Insert custom text'
    $('.cfwc-custom-field-wrapper span').hide()

    $('#cfwc-title-field').keyup(function () {
      if ($(this).val() == '') {
        $('.cfwc-custom-field-wrapper span').hide()
      } else {
        $('.cfwc-custom-field-wrapper span').show()
      }
    });

    $('.cfwc-custom-field-wrapper span').click(function () {
      $(this).hide();
    })

    //breadcrumbs
    if ($('nav.woocommerce-breadcrumb')) {
      $('nav.woocommerce-breadcrumb').insertAfter('h1.product_title.entry-title');
    }

    //end
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/product.js